import { DefaultDetailContext } from 'src/app/controls/forms/default-detail-context';
import { IRole } from 'src/app/models/interfaces/role.interface';

export class RoleDetailContext extends DefaultDetailContext<IRole, number> {}
